import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { CreateCollection, ListCollection } from '.';
import { Mixpanel } from '../../common/utils/mixpanelUtil';
import ParentDocCard from '../common/ParentDocCard';
export class AddCollectionInProject extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    status: '',
    selectedCollection: null,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadCollectionForProjectOnBoard({ projectId, version });
  }

  changeStatus = (status) => {
    this.setState({ status });
  };

  skipToNextStep = () => {
    const { projectId, version } = this.props.match.params;
    Mixpanel.track('Clicked on- Proceed: Add More Plugins');
    this.props.actions.changeProjectStatus({
      state: 'COLLECTION_CREATED',
      status: 'PENDING',
      projectId,
      version,
    });
    this.props.history.push(`/project-on-board/${version}/v/${projectId}/add-more-plugin`);
  };

  render() {
    const { status } = this.state;
    const { match, actions } = this.props;
    const { changeProjectStatus } = actions;
    const { projectId, version } = match.params;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-violet"
                  >
                    <i className={`wb ${drapcodeIcon('collection')}`}></i>
                  </div>
                  <div className="card-content">
                    <div className="card-title-header">
                      <h4 className="card-title">Add Collections in your Project</h4>
                      <div className="card-cta">
                        {!status && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              this.changeStatus('CREATE_COLLECTION');
                              Mixpanel.track(
                                'Clicked on- Add Collection button on Project Onboarding',
                              );
                            }}
                          >
                            <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Add Collection
                          </button>
                        )}
                        {status === 'CREATE_COLLECTION' && (
                          <button
                            type="button"
                            className="btn btn-default"
                            onClick={() => {
                              this.changeStatus('');
                              Mixpanel.track(
                                'Clicked on- Add Collection Cancel button on Project Onboarding',
                              );
                            }}
                          >
                            <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div className="card-description mb-5">
                        <h5>
                          If you have installed the Login/Signup plugin, then two default
                          collections are added already. You can add more collections, if you want,
                          to build your custom database.
                        </h5>
                      </div>
                    </div>

                    {status === 'CREATE_COLLECTION' && (
                      <div className="row mx-auto">
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                          <CreateCollection
                            projectId={projectId}
                            version={version}
                            changeStatus={this.changeStatus}
                            changeProjectStatus={changeProjectStatus}
                          />
                        </div>
                      </div>
                    )}
                    <ListCollection projectId={projectId} />
                    <div className="row mt-3">
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={this.skipToNextStep}
                        >
                          <i className={`wb ${drapcodeIcon('next')}`}></i>&nbsp; Proceed: Add More
                          Plugins
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ParentDocCard></ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCollectionInProject);
